import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { AiOutlineCloseCircle } from 'react-icons/ai'
import { MdDragIndicator } from 'react-icons/md'

import Button from 'src/components/Custom/Button/Button'
import HeadingLevel from 'src/components/Custom/Heading/Heading'
import { transformImage } from 'src/lib/images'

import { Audiostream } from './Audiostream'

interface AudiostreamItemProps {
  item: Audiostream
  loading: boolean
  onClick: (item: Audiostream) => void
  onDelete: (id: string) => Promise<void>
}

const LOGO_PREVIEW_SIZE = {
  height: 50,
  width: 100,
}

const AudiostreamItem = ({
  item,
  loading,
  onClick,
  onDelete,
}: AudiostreamItemProps) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({
      id: item.id,
    })

  const style = {
    transform: CSS.Translate.toString(transform),
    transition,
  }

  const handleEditButtonClick = () => {
    onClick(item)
  }

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="rounded-lg border border-gray-200 bg-white p-4"
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <MdDragIndicator
            size="30"
            className="text-gray-500"
            {...listeners}
            {...attributes}
          />
          {item.logo && (
            <img
              height={LOGO_PREVIEW_SIZE.height}
              width={LOGO_PREVIEW_SIZE.width}
              src={transformImage({
                imageUrl: item.logo,
                options: {
                  height: LOGO_PREVIEW_SIZE.height * 4,
                  width: LOGO_PREVIEW_SIZE.width * 4,
                },
              })}
              alt="logo"
            />
          )}
          <HeadingLevel level={3}>{item.name}</HeadingLevel>
        </div>
        <div className="flex items-center justify-end space-x-3">
          <Button title="Edit" onClick={handleEditButtonClick} />
          <Button
            title="Delete"
            outlineColor="border-red-600 text-red-600 hover:border-red-700 hover:text-red-700"
            icon={<AiOutlineCloseCircle size="16px" />}
            onClick={() => {
              onDelete(item.id)
            }}
            isDisabled={loading}
          />
        </div>
      </div>
    </div>
  )
}

export default AudiostreamItem
